import { useEffect, useState } from 'react'

let activeSample: HTMLAudioElement | null = null

const stopActiveSample = () => {
  if (activeSample) {
    activeSample.pause()
    activeSample.onended = null
    activeSample = null
  }
}

export const useAudioSample = () => {
  const [playingKey, setPlayingKey] = useState<string | null>(null)

  const toggle = (key: string | null, url: string | null = key) => {
    stopActiveSample()
    if (!key || !url || playingKey === key) {
      setPlayingKey(null)
      return
    }
    const audio = new Audio(url)
    activeSample = audio
    setPlayingKey(key)
    void audio.play()
    audio.onended = () => {
      activeSample = null
      setPlayingKey(null)
    }
  }

  useEffect(() => () => stopActiveSample(), [])

  return { playingKey, toggle }
}
